"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MATCH_STATE_LIKE = exports.MATCH_STATE_DISLIKE = exports.JudgementsContext = exports.JudgementsActionsContext = exports.IN_PROGRESS = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Pc = require("@jobmatchme/amplify-tools/es/api/Pc");

var _reactI18next = require("react-i18next");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var JudgementsContext = /*#__PURE__*/_react.default.createContext({
  userLikes: [],
  userDislikes: [],
  userLikesWithMatchData: [],
  loaded: false
});

exports.JudgementsContext = JudgementsContext;

var JudgementsActionsContext = /*#__PURE__*/_react.default.createContext({
  fetchJudgements: function fetchJudgements() {
    return Promise.resolve();
  },
  hydrateJoboffers: function hydrateJoboffers() {},
  judgeMatch: function judgeMatch() {}
});

exports.JudgementsActionsContext = JudgementsActionsContext;
var MATCH_STATE_LIKE = 'like';
exports.MATCH_STATE_LIKE = MATCH_STATE_LIKE;
var MATCH_STATE_DISLIKE = 'dislike';
exports.MATCH_STATE_DISLIKE = MATCH_STATE_DISLIKE;
var IN_PROGRESS = 'IN_PROGRESS';
/**
 * Returns an array with jobUuids for the given judgement.
 * @param {Array} items
 * @param {String} judgement
 */

exports.IN_PROGRESS = IN_PROGRESS;

var uuidsByJudgement = function uuidsByJudgement(judgements, judgementType) {
  return judgements.filter(function (j) {
    return j.judgement.judgement === judgementType;
  }).map(function (j) {
    return j.judgement.jobUuid;
  });
};

var JudgementsProvider = function JudgementsProvider(_ref) {
  var children = _ref.children,
      matchingConfig = _ref.matchingConfig;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)({
    userLikes: [],
    userDislikes: [],
    userLikesWithMatchData: [],
    loaded: false
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      judgements = _useState2[0],
      setJudgements = _useState2[1];
  /**
   * Returns an array with objects jobUuid, matchStatus, matchTimestamp for the given judgement.
   * @param {Array} items
   * @param {String} judgement
   */


  var getUuidsAndMatchesStatus = function getUuidsAndMatchesStatus(judgements, judgementType) {
    return judgements.filter(function (j) {
      return j.judgement.judgement === judgementType;
    }).map(function (j) {
      return {
        jobUuid: j.judgement.jobUuid,
        matchStatus: j.matchStatus,
        matchTimestamp: j.matchTimestamp,
        jobRevision: j.judgement.jobRevision
      };
    });
  };

  var hydrateJoboffers = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var loadSpecificJoboffer, jobsToHydrate, results;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            loadSpecificJoboffer = /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(jobUuid, jobRevision) {
                var result;
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return _Pc.PcApi.get("/bcService/joboffer/".concat(jobUuid, "?revision=").concat(jobRevision));

                      case 3:
                        result = _context.sent;
                        // Default potentially empty display name, to avoid infinite loading
                        result.displayName = result.displayName || '';
                        _context.next = 10;
                        break;

                      case 7:
                        _context.prev = 7;
                        _context.t0 = _context["catch"](0);
                        // Mark missing joboffers as not found
                        result = {
                          id: jobUuid,
                          displayName: t('pc-matching:LikedMatches.notFound'),
                          location: {
                            name: ' ',
                            latitude: '',
                            longitude: ''
                          }
                        };

                      case 10:
                        return _context.abrupt("return", result);

                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 7]]);
              }));

              return function loadSpecificJoboffer(_x, _x2) {
                return _ref3.apply(this, arguments);
              };
            }();

            jobsToHydrate = judgements.userLikesWithMatchData.filter(function (like) {
              return !!!like.minimalJoboffer;
            });

            if (!(jobsToHydrate.length > 0)) {
              _context2.next = 7;
              break;
            }

            _context2.next = 5;
            return Promise.all(jobsToHydrate.map(function (_ref4) {
              var jobUuid = _ref4.jobUuid,
                  jobRevision = _ref4.jobRevision;
              return loadSpecificJoboffer(jobUuid, jobRevision);
            }));

          case 5:
            results = _context2.sent;

            if (results.length > 0) {
              setJudgements(function (state) {
                return (0, _extends2.default)({}, state, {
                  userLikesWithMatchData: state.userLikesWithMatchData.map(function (like) {
                    return (0, _extends2.default)({
                      minimalJoboffer: results.find(function (joboffer) {
                        return joboffer.id === like.jobUuid;
                      })
                    }, like);
                  })
                });
              });
            }

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [judgements.userLikesWithMatchData, t]);
  /**
   * Fetch the Judgements (likes, dislikes) the user has given in the past and
   * mark the matching joboffers as likes / dislikes.
   */

  var fetchJudgements = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var authHeaders;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _Pc.PcApi.graphql_headers();

          case 2:
            authHeaders = _context3.sent;

            _Pc.PcApi.get("/matchingService/judgements", authHeaders).then(function (response) {
              var userLikes = uuidsByJudgement(response, MATCH_STATE_LIKE);
              setJudgements({
                userLikes: userLikes,
                userDislikes: uuidsByJudgement(response, MATCH_STATE_DISLIKE),
                userLikesWithMatchData: getUuidsAndMatchesStatus(response, MATCH_STATE_LIKE),
                loaded: true
              });
            }) // This is a workaround for the backend failure due to empty revisions
            .catch(function () {
              setJudgements(function (judgements) {
                return (0, _extends2.default)({}, judgements, {
                  loaded: true
                });
              });
            });

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), []);
  var judgeMatch = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(judgement, jobUuid, jobRevision, pcRevision, source, meta) {
      var authHeaders;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _Pc.PcApi.graphql_headers();

            case 2:
              authHeaders = _context4.sent;

              _Pc.PcApi.post("/matchingService/judgements/".concat(matchingConfig.discriminator, "/").concat(pcRevision, "/").concat(jobUuid, "/").concat(jobRevision, "/").concat(judgement), {
                meta: meta,
                source: source
              }, authHeaders).then(function () {
                setJudgements(function (state) {
                  return {
                    userLikes: state.userLikes.concat(judgement === MATCH_STATE_LIKE ? [jobUuid] : []),
                    userLikesWithMatchData: state.userLikesWithMatchData.concat(judgement === MATCH_STATE_LIKE ? [{
                      jobUuid: jobUuid,
                      matchStatus: IN_PROGRESS,
                      matchTimestamp: Date.now(),
                      jobRevision: jobRevision
                    }] : []),
                    userDislikes: state.userDislikes.concat(judgement === MATCH_STATE_DISLIKE ? [jobUuid] : []),
                    loaded: true
                  };
                });
              });

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x3, _x4, _x5, _x6, _x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }(), [matchingConfig.discriminator]);
  var actions = (0, _react.useMemo)(function () {
    return {
      fetchJudgements: fetchJudgements,
      judgeMatch: judgeMatch,
      hydrateJoboffers: hydrateJoboffers
    };
  }, [fetchJudgements, hydrateJoboffers, judgeMatch]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(JudgementsActionsContext.Provider, {
    value: actions,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(JudgementsContext.Provider, {
      value: judgements,
      children: children
    })
  });
};

var _default = JudgementsProvider;
exports.default = _default;